export default __webpack_public_path__ + "c1de20c44777f9821e1ed4a3f6cee5f4.png";